<template>
<div>
  <Tweet :id="tweet_id" error-message="ツイートを読み込めませんでした"
         :options="{lang: 'ja', dnt: false }" class="emb-tweet"><div class="spinner"></div></Tweet>
  <b-modal :active.sync="is_image_open">
    <p class="image is-4by3">
      <img :src="img_url">
    </p>
  </b-modal>
</div>
</template>

<script>
import { Tweet } from 'vue-tweet-embed'

export default {
  components: {
    Tweet
  },
  data() {
    return {
      is_image_open: false,
      img_url: "https://pbs.twimg.com/media/Ea4Fk_0U8AIzBSc.jpg",
    }
  },
  props: ['tweet_id'],
  mounted() {
    const monitored = this.$el.getElementsByClassName('emb-tweet')[0]
    const observer = new MutationObserver(()=> this.delete_tweet_info())
    const config = {childList: true}; // オブザーバの設定
    observer.observe(monitored, config); // ツイート読み込み時にスタイル変更
  },
  methods: {
    delete_tweet_info() {
      var tweetCSS = ".TweetInfo{display:none !important;}\
                      .CallToAction{display:none !important;}\
                      .EmbeddedTweet{border-width:0px !important;}"  // 上書きしたいCSS
      var tweetStyle = document.createElement("style")
      tweetStyle.innerHTML = tweetCSS
      tweetStyle.type = "text/css"

      const tweet_card_dom = this.$el.getElementsByClassName('twitter-tweet')  // tweetのDOMを取得
      if(tweet_card_dom.length == 0){return}
      // 下の不要な情報を消す
      const tweet_shadow_root = tweet_card_dom[0].shadowRoot
      if(tweet_shadow_root == null){return}
      tweet_shadow_root.insertBefore(tweetStyle, tweet_shadow_root.childNodes[0])
      // 画像をモーダルで表示できるようにする
      const image_area = tweet_shadow_root.querySelector("div > div > blockquote > div.Tweet-body.e-entry-content > div.Tweet-card > article > div > div")
      if(image_area == null){return}
      const multiple_image_area = image_area.getElementsByTagName('a')
      if(multiple_image_area != null){
        multiple_image_area.forEach(element => {
          element.removeAttribute('href')
          const img_info = element.querySelector("img")
          if(img_info != null){
            if(img_info.getAttribute("data-image-format") != null){
              const img_url = img_info.getAttribute("data-image") + "." + img_info.getAttribute("data-image-format")
              element.onclick = () => {
                this.is_image_open = true
                this.img_url = img_url
              }
            }
          }
        })
      }
    },
  }
}
</script>

<style lang="scss">
.twitter-tweet {
	max-width: 400px !important;
	width: initial !important;
	margin-left: auto;
	margin-right: auto;
  margin-bottom: 0px !important;
  margin-top: 0px !important;
}
</style>